import { DragGesture } from '@use-gesture/vanilla';

// Translate recognized drag movement into discrete game buttons. The library
// owns pointer tracking, capture, tap detection, and gesture cancellation.
export class StrokeDirection {
    constructor(x, y) { this.x = x; this.y = y; this.direction = null; }
    move(x, y) {
        const dx = x - this.x, dy = y - this.y;
        const ax = Math.abs(dx), ay = Math.abs(dy);
        if (Math.max(ax, ay) < 14 || Math.max(ax, ay) < Math.min(ax, ay) * 1.2) return null;
        const direction = ax > ay ? (dx > 0 ? 'ArrowRight' : 'ArrowLeft') : (dy > 0 ? 'ArrowDown' : 'ArrowUp');
        this.x = x; this.y = y;
        if (this.direction === direction) return null;
        this.direction = direction;
        return direction;
    }
}

export function bindTouchpad(pad, { enabled, send }) {
    let stroke, cancel;
    const clear = () => { stroke = null; cancel = null; pad.classList.remove('is-active'); };
    const reset = () => { const cancelGesture = cancel; clear(); cancelGesture?.(); };
    const dispatch = code => { if (code && enabled()) send(code); };
    new DragGesture(pad, state => {
        if (state.canceled || /cancel|lostpointercapture/.test(state.event.type)) { clear(); return; }
        if (!enabled()) { clear(); state.cancel(); return; }
        cancel = state.cancel;
        if (state.first) stroke = new StrokeDirection(...state.initial);
        pad.classList.toggle('is-active', state.active);
        if (state.last) {
            if (state.tap && state.elapsedTime <= 400) dispatch('Space');
            clear();
        } else if (state.active && stroke) {
            dispatch(stroke.move(...state.values));
        }
    }, {
        filterTaps: true,
        tapsThreshold: 10,
        threshold: 0,
        preventDefault: true,
        eventOptions: { passive: false },
        pointer: { keys: false }
    });
    pad.addEventListener('contextmenu', event => event.preventDefault());
    // Native button activation supports keyboard and assistive technology.
    pad.addEventListener('click', event => { if (event.detail === 0) dispatch('Space'); });
    pad.addEventListener('keydown', event => {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].includes(event.key)) {
            event.preventDefault(); dispatch(event.key);
        }
    });
    return reset;
}
